export default __webpack_public_path__ + "static/media/right-black.1198a0e8.svg";